import type { ReactNode } from 'react';
import { createContext } from 'react';
import type { FormatType } from '../useRichTextEditor';
import type { Editor } from '@tiptap/core';

type ContextType = {
  isActive: (formatType: FormatType) => boolean | undefined;
  format: (formatType: FormatType) => void;
  handleFileUpload: (file: File | null) => Promise<string | null>;
  enableImages: boolean;
  editor: Editor | null;
  characterLimit: number | undefined;
};

export const RichTextEditorContext = createContext<ContextType>({
  isActive: () => undefined,
  format: () => {},
  handleFileUpload: () => Promise.resolve(null),
  enableImages: false,
  editor: null,
  characterLimit: undefined,
});

type Props = {
  children: ReactNode;
} & ContextType;

export const RichTextEditorProvider = ({
  children,
  isActive,
  format,
  handleFileUpload,
  enableImages,
  editor,
  characterLimit,
}: Props) => {
  return (
    <RichTextEditorContext.Provider
      value={{
        isActive,
        format,
        handleFileUpload,
        enableImages,
        editor,
        characterLimit,
      }}
    >
      {children}
    </RichTextEditorContext.Provider>
  );
};
